// src/redux/searchSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { searchApi } from '../services/searchService';
import { ACTIONS } from '../constants/apiEndpoints';

// 🔹 Thunk for member search
export const search = createAsyncThunk(
  ACTIONS.search,
  async (searchDto, { rejectWithValue }) => {
    try {
      const response = await searchApi(searchDto);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const searchSlice = createSlice({
  name: 'search',
  initialState: {
    data: null,
    statuscode: null,
    message: null,
    description: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearSearch: (state) => {
      state.data = null;
      state.statuscode = null;
      state.message = null;
      state.description = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(search.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(search.fulfilled, (state, action) => {
        state.loading = false;
        const { statuscode, message, description, data } = action.payload;
        state.statuscode = statuscode;
        state.message = message;
        state.description = description;
        state.data = data;
      })
      .addCase(search.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearSearch } = searchSlice.actions;
export default searchSlice.reducer;
